module.exports = __webpack_public_path__ + "img/default_img31.381bc30e.jpg";